import React from "react";
import dayjs from "dayjs";
import type { EnquiryHrComment } from "./enquiry-hr-types";

type EnquiryHrCommentsProps = {
    comments: EnquiryHrComment[];
};

const formatCommentTime = (value: string) => dayjs(value).format("DD MMM YYYY, hh:mm A");

export const EnquiryHrComments = ({ comments }: EnquiryHrCommentsProps) => {
    if (!comments.length) return null;

    return (
        <div className="mt-4 space-y-2 border-t border-gray-100 pt-4">
            <p className="text-xs font-medium text-gray-500">Comments</p>
            {comments.map((item) => (
                <div
                    key={item.id}
                    className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2"
                >
                    <div className="flex items-center justify-between gap-2">
                        <span className="text-sm font-medium text-violet-700">{item.author}</span>
                        <span className="text-xs text-gray-400">{formatCommentTime(item.createdAt)}</span>
                    </div>
                    <p className="mt-1 whitespace-pre-wrap text-sm text-gray-800">{item.text}</p>
                </div>
            ))}
        </div>
    );
};
